
import { Component } from '@niknevis/vue-modules'
import AdminCouponBaseForm from '@/modules/coupon/components/admin/base/AdminCouponBaseForm.vue'
import { AdminStoreCouponUseCase } from '@/modules/coupon/use-cases/admin-store-coupon.use-case'

@Component
export default class AdminCouponCreateForm extends AdminCouponBaseForm {
  constructor(
    private readonly useCase: AdminStoreCouponUseCase
  ) {
    super()
  }

  protected get loadingState(): boolean {
    return this.loading || this.__loadingState || this.useCase.isLoading
  }

  protected onSubmit() {
    this.useCase.execute(this.requestData)
      .onSuccess(() => {
        this.$emit('success')
      })
  }
}
